import * as Sentry from '@sentry/browser';
import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query';
import useTokenQuery from 'hooks/useTokenQuery';

import { Duration } from '../constants';

const redirectToForbidden = () => {
  if (!window.location.pathname.includes('/403')) {
    window.location.href = '/403';
  }
};

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      gcTime: Duration.Hour,
      staleTime: Duration.Minute * 5,
      networkMode: 'always',
    },
    mutations: {
      networkMode: 'always',
    },
  },
  queryCache: new QueryCache({
    onError: (error: any) => {
      if (error?.response?.status === 403) {
        redirectToForbidden();
        return;
      }
      if (error?.response?.status === 503 && !window.location.href.includes('/maintenance')) {
        window.location.href = '/app/op/maintenance';
      }
      if (error.response?.status === 400 || (error.response?.status >= 402 && error.response?.status < 500)) {
        Sentry.captureException(error);
      }
      if (error.response?.status === 401) {
        queryClient.invalidateQueries({ queryKey: useTokenQuery.getKey() });
      }
    },
  }),
  mutationCache: new MutationCache({
    onError: (error: any) => {
      if (error?.response?.status === 403) {
        redirectToForbidden();
      }
    },
  }),
});
